import React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import {
   Container,
   Header,
   Button,
   Icon,
   Divider,
   Modal,
   Tab,
} from 'semantic-ui-react'
import FormComponent from '../Form'
import mediaForm from './config/media-form'
import { AutoLabel, EventsList } from '../Common'
import { withAuthentication } from '../Session'
import { ROUTES } from '../../constants'
import { TabWidget } from '../Widgets'
import { labelHelper } from '../Helpers'
import labels from '../Common/translations'
import TableComponent from '../Table'
import sharesList from './config/shares-list'

class MediaShowPage extends React.Component {
   constructor(props) {
      super(props)
      this.state = { open: false }
      this.goBack = this.goBack.bind(this)
      this.modalRef = React.createRef()
   }

   lb = new labelHelper(
      labels,
      this.props.authUser ? this.props.authUser.lang : labelHelper.lang
   )

   async componentDidMount() {
      this.setState({ loading: true })
      const { data: item } = await mediaForm.actions.read(
         `medias/${this.props.match.params.id}`
      )

      this.setState({
         item,
         loading: false,
      })
   }

   goBack() {
      this.props.history.push(ROUTES.MEDIAS)
   }

   accessList = () => {
      this.setState({ open: true })
   }

   close = () => this.setState({ open: false })

   panes = [
      {
         key: 'details',
         menuItem: this.lb._(labels.screens.detail),
         render: () => (
            <Tab.Pane key="details">
               <FormComponent
                  form={mediaForm}
                  data={this.state.item}
                  {...this.props}
               />
            </Tab.Pane>
         ),
      },
      {
         key: 'shares',
         menuItem: this.lb._(labels.screens.medias_shares),
         render: () => (
            <Tab.Pane key="shares">
               <TableComponent
                  title={<AutoLabel labelKey="screens.video3d_shares" />}
                  list={sharesList}
                  compact={true}
                  pagination={false}
                  baseRef={`medias/${this.props.match.params.id}`}
               />
            </Tab.Pane>
         ),
      },
      {
         key: 'event',
         menuItem: this.lb._(labels.fields.event),
         render: () => (
            <Tab.Pane key="event">
               <EventsList
                  labelKey="screens.relatedEvents"
                  hideObjectColumn={true}
                  condition={{
                     object: [
                        `environments/${this.state.item.uid}`,
                        '==',
                        'ref',
                     ],
                  }}
                  {...this.props}
               />
            </Tab.Pane>
         ),
      },
   ]

   render() {
      if (!this.state.item) {
         return <div />
      }

      const {
         item: { name },
      } = this.state
      return (
         <Container>
            <Container>
               <Header as="h1">{name}</Header>
               <Button primary icon labelPosition="left" onClick={this.goBack}>
                  <Icon name="left arrow" />
                  <AutoLabel labelKey="form.back" />
               </Button>
               <Divider hidden />
               <Container>
                  <Modal
                     open={this.state.open}
                     ref={this.modalRef}
                     closeIcon
                     content={this.state.content}
                     onClose={this.close}
                     closeOnEscape={false}
                     header={this.state.modalHeader}
                  />
               </Container>
               <TabWidget panes={this.panes} />
            </Container>
         </Container>
      )
   }
}

export default compose(withRouter, withAuthentication)(MediaShowPage)
